import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useSubscription } from '../../../contexts/context/SubscriptionContext';
import agthealthService from '../../../services/agthealthService';

const IntercomProvider = ({ user }) => {
  const theme = useTheme();
  const { isPro, status, trialActive } = useSubscription();
  const [isInitialized, setIsInitialized] = useState(false);
  const [userData, setUserData] = useState(null);

  // Efecto para cargar los datos del usuario si no están completos
  useEffect(() => {
    const loadUserData = async () => {
      if (user && user.email && (!user.id || !user.firstName)) {
        try {
          console.log("Intentando cargar datos de usuario desde la API...");
          const response = await agthealthService.getUserProfile();
          if (response && response.success && response.data) {
            const apiUserData = {
              id: response.data.id || user.id || user.email,
              email: response.data.email || user.email,
              firstName: response.data.firstName || user.firstName || '',
              lastName: response.data.lastName || user.lastName || '',
              createdAt: response.data.createdAt
            };
            console.log("Datos de usuario cargados desde API:", apiUserData);
            setUserData(apiUserData);
          }
        } catch (error) {
          console.error("Error al cargar datos de usuario:", error);
          // Si falla, usamos lo que tenemos
          setUserData(user);
        }
      } else {
        setUserData(user);
      }
    };

    if (user) {
      loadUserData();
    }
  }, [user]);

  useEffect(() => {
    // Solo inicializar cuando tengamos datos válidos
    if (userData && userData.email) {
      // Asegurarnos de que tenemos un ID - usar email si no hay ID
      const validUserId = userData.id || userData.email;
      
      if (validUserId) {
        console.log('Inicializando Intercom con usuario:', validUserId);
        
        try {
          // Asegurarse de que el script de Intercom esté cargado
          if (!window.Intercom) {
            console.log('Cargando script de Intercom...');
            
            // Crear y añadir el script de Intercom
            const script = document.createElement('script');
            script.async = true;
            script.src = "https://widget.intercom.io/widget/k91garrd";
            
            script.onload = () => {
              console.log('Script de Intercom cargado, inicializando...');
              initializeIntercom(validUserId);
            };
            
            document.head.appendChild(script);
          } else {
            // Si ya existe, inicializar directamente
            initializeIntercom(validUserId);
          }
        } catch (error) {
          console.error('Error al inicializar Intercom:', error);
        }
      } else {
        console.log('Usuario no tiene ID válido para inicializar Intercom', userData);
      }
    } else {
      console.log('Usuario no disponible para inicializar Intercom', userData);
    }

    function initializeIntercom(userId) {
      window.Intercom('boot', {
        app_id: 'k91garrd',
        user_id: String(userId),
        name: userData.firstName && userData.lastName 
          ? `${userData.firstName} ${userData.lastName}`.trim()
          : (userData.email ? userData.email.split('@')[0] : 'Usuario'),
        email: userData.email || '',
        created_at: userData.createdAt 
          ? Math.floor(new Date(userData.createdAt).getTime() / 1000)
          : Math.floor(Date.now() / 1000),
        
        // Datos adicionales personalizados
        is_pro: isPro || false,
        subscription_status: status || 'free',
        trial_active: trialActive || false,
        theme: theme.palette.mode,
        language: 'es'
      });

      setIsInitialized(true);
      console.log('Intercom inicializado correctamente');
    }

    // Cleanup al desmontar
    return () => {
      try {
        if (window.Intercom) {
          window.Intercom('shutdown');
          console.log('Intercom cerrado correctamente');
        }
      } catch (error) {
        console.log('Error al cerrar Intercom:', error);
      }
    };
  }, [userData, isPro, status, trialActive, theme.palette.mode]);

  return null;
};

export default IntercomProvider;